export enum Entity {
  Count = 'count',
  Category = 'category',
  Date = 'date',
  Total = 'total',
}
